import { OpenNewTabTargetType } from "@voltmoney/types";
import { clearAllData } from "../../configs/utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { StoreKey } from "../../configs/api";
import { ROUTE } from "../../routes";
import { navigateByUrl } from "../partnerWeb_Dashboard/utils";
import { PartnerAccountType, ROUTE_PARTNER } from "../../configs/constants";
export const YesAction = async (action, _datastore, { navigate, hidePopup, instrumentTrack, asyncStorage, openNewTab }) => {
    instrumentTrack("LOGOUT_BUTTON_CLICKED");
    const _user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    const partnerAccountType = _user?.linkedPartnerAccounts[0]?.partnerAccountType;
    await clearAllData();
    await AsyncStorage.removeItem(StoreKey.userContext);
    await AsyncStorage.removeItem(StoreKey.U_DATA);
    await AsyncStorage.removeItem(StoreKey.accessToken);
    await AsyncStorage.removeItem("PLJ_borrowerAccountId");
    await asyncStorage.remove(StoreKey.EXTERNAL_ROUTE);
    switch (partnerAccountType) {
        case PartnerAccountType.AFFILIATE:
            await openNewTab(`/partner/${ROUTE_PARTNER.AFFILIATE_SIGNUP}/`, OpenNewTabTargetType.self);
            break;
        default:
            await navigateByUrl(ROUTE.PARTNER_SIGNUP, openNewTab, true);
            break;
    }
};
export const NoAction = async (action, _datastore, { hidePopup }) => {
    console.warn('**** NoAction Action Triggered ****', action);
    await hidePopup();
};
